import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { authenticate } from '../webAPI/userService';
import { doSetAuthenticatedUser } from '../reducers/user';

import {
	TextField,
	PasswordField,
	Checkbox,
	PrimaryButton,
	FlatPrimaryButton
} from '../Ui';
import Icon from '../common/components/Icon';

class AuthenticateContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			login: '',
			password: '',
			memorize: true,
			isFetching: false
		};

		this._handleInputChange = this._handleInputChange.bind(this);
		this._handleCheckboxChange = this._handleCheckboxChange.bind(this);
	}

	render() {
		//if (!this.props.showModal) return null;
		const encodedProjectId = encodeURIComponent(
			this.props.params.projectId
		);
		const encodedLocation = encodeURIComponent(
			this.props.location.pathname
		);
		return (
			<div className="l-modal-wrapper">
				<div className="auth-modal">
					<header className="auth-modal__header">
						<Icon
							className="auth-modal__background-icon"
							icon="binoculars"
						/>
						Fin du mode découverte
					</header>
					<div className="auth-modal__content">
						<p>Connectez-vous avec vos identifiants Legallais</p>
						<div className="auth-modal__block">
							<TextField
								label="Identifiant"
								name="login"
								value={this.state.login}
								onChange={this._handleInputChange}
							/>
						</div>
						<div className="auth-modal__block">
							<PasswordField
								label="Mot de passe"
								value={this.state.password}
								name="password"
								onChange={this._handleInputChange}
							/>
						</div>
						<div className="auth-modal__block flex flex--justify-between flex--align-center">
							<label className="auth__checkbox-label">
								<Checkbox
									name="memorize"
									checked={this.state.memorize}
									onClick={this._handleCheckboxChange}
								/>
								Mémoriser mes identifiants
							</label>
							<a
								href="http://www.legallais.com/user/forgotpassword/"
								target="#blank"
							>
								<FlatPrimaryButton>
									Mot de passe oublié ?
								</FlatPrimaryButton>
							</a>
						</div>
						<div className="auth-modal__block">
							<PrimaryButton
								loading={this.state.isFetching}
								fillWidth
								onClick={() => this._handleSubmit()}
							>
								Se connecter et voir l'offre
							</PrimaryButton>
						</div>
						<hr />
						<p
							className="flex flex--justify-between"
							style={{ height: '30px' }}
						>
							Vous n'avez pas de compte Legallais ?
							<a
								href={
									'http://www.legallais.com/ouverture-compte.html/?project_id=' +
										encodedProjectId +
										'&redirect_to=' +
										encodedLocation
								}
								target="#blank"
							>
								<FlatPrimaryButton>
									S'inscrire sur legallais.com
								</FlatPrimaryButton>
							</a>
						</p>
					</div>
				</div>
			</div>
		);
	}

	_handleInputChange(newFieldValue, fieldName) {
		this.setState({ [fieldName]: newFieldValue });
	}

	_handleCheckboxChange(newCheckboxChecked) {
		this.setState({ memorize: newCheckboxChecked });
	}

	_handleSubmit() {
		const { projectId } = this.props.params;
		const { login, password } = this.state;

		this.setState({ isFetching: true });

		authenticate(login, password, projectId).then(
			error => this.setState({ isFetching: false }),
			result => {
				const { user } = result;

				const formattedUser = {
					firstname: user.firstname,
					lastname: user.lastname,
					email: user.email,
					civility: user.civility_title
				};

				doSetAuthenticatedUser(formattedUser);
				location.reload();
			}
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	showModal: state.authenticate.showAuthenticateModal
});

export default withRouter(connect(mapStateToProps)(AuthenticateContainer));



// WEBPACK FOOTER //
// ./src/js/app/AuthenticateContainer.js